import { Gift } from "@/types/gift";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type HomeData = {
  customer: any;
  financial_transactions: any;
  currency_rate: any;
  /** Sign-in's starting send amount for the home calculator. Absent on older snapshots. */
  default_from_amount?: number | null;
};

type IndividualAccount = {
  id: number;
  name: string;
};

type HomeStore = {
  homeData: HomeData | null;
  setHomeData: (data: HomeData) => void;
  clearHomeData: () => void;
  individualAccount: IndividualAccount | null;
  setIndividualAccount: (account: IndividualAccount) => void;
  gift: Gift[] | null;
  setGift: (gift: Gift[] | null) => void;
  clearGift: () => void;
  selectedAccountId: string | null;
  setSelectedAccountId: (id: string | null) => void;
};

export const useHomeStore = create<HomeStore>()(
  persist(
    (set) => ({
      homeData: null,
      setHomeData: (data) => set({ homeData: data }),
      clearHomeData: () => set({ homeData: null }),

      individualAccount: null,
      setIndividualAccount: (account) => set({ individualAccount: account }),

      gift: null,
      setGift: (account) => set({ gift: account }),
      clearGift: () => set({ gift: null }),

      selectedAccountId: null,
      setSelectedAccountId: (id) => set({ selectedAccountId: id }),
    }),
    {
      name: "home-storage",
    },
  ),
);

/**
 * Logout must not leave the previous customer's snapshot in localStorage, so this
 * resets every field and then removes the persisted "home-storage" key itself.
 */
export function resetHomeStore() {
  useHomeStore.setState({
    homeData: null,
    individualAccount: null,
    gift: null,
    selectedAccountId: null,
  });
  useHomeStore.persist.clearStorage();
}
